<template>
<div class="h-full w-full max-w-1440 mx-auto">
    <div class="flex h-full">
        <div class="w-2/12 xl:w-1/5 ml-auto overflow-hidden h-full rounded shadow">
            <settings-menu></settings-menu>
        </div>

        <div class="w-10/12 xl:w-4/5 h-full px-16 self-start">
            <div class="bg-white rounded h-full overflow-y-scroll shadow px-48 pt-48 overflow-auto">
                <router-view></router-view>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SettingsMenu from '../components/navigation/SettingsMenu.vue';
import {mapActions} from 'pinia';
import {useMainStore} from '../state/store';
import SvgIcon from '../components/ui/SvgIcon.vue';
import Error403 from '../components/ui/Error403.vue';

export default {
    components: {
        'settings-menu': SettingsMenu,
        'svg-icon': SvgIcon,
        'error-403': Error403,
    },
    computed: {
        can () {
            return this.$can([
                'companies.update',
                'jobsites.update',
                'email_templates.create',
                'email_templates.update',
                'email_templates.delete',
                'company_items.create',
                'company_items.update',
                'company_items.delete',
                'locations.create',
                'locations.update',
                'locations.delete',
                'roles.create',
                'roles.update',
                'roles.delete',
                'companies.update',
                'tags.create',
                'tags.update',
                'tags.delete',
                'competences.create',
                'competences.update',
                'competences.delete',
                'questions.create',
                'questions.update',
                'questions.delete',
                'jobs.manage'
            ]);
        }
    },
    methods: {
        ...mapActions(useMainStore, ['setDocumentTitle']),
    },
    mounted() {
        this.setDocumentTitle(this.$t('settings.title'));
    },
}
</script>
